export * from './Headers.Constant';
export * from './Routing.Constant';
export * from './BreadcrumbElements.Constants';
export * from './TicketStatus.Constants';
export * from './ServiceRequestDefaultSettings.Constant';
export * from './QueryString_Keys.Constant';
export * from './SupportPanelEvents.Constant';
export * from './ActionTypes.Constants';
export * from './TraceTypes.Constants';
export * from './StaticLinks';
export * from './ServiceHealth.Constants';
export * from './WorkspaceId.Constants';
export * from './ServiceRequestActivityTypes';
export * from './ThemeStrings';
export * from './Flights.Constants';

export const DateFormat = 'MM/DD/YYYY';
export const PartnerAccountInfo = 'PartnerAccountInfo';
export const BrowserInfo = 'BrowserInfo';
export const PartnerSupportDataFileName = '_ScopedTemplateData.json';
export const DayToMilliSecondsFactor = 24 * 60 * 60 * 1000;
export const ClientSessionContextReadyEvent = 'client-session-context-ready';
export const AuthContextFDReadyEvent = 'auth-context-ready';
export const SupportHTMLSpinner = 'support-spinner';
